<template>
  <dt class="col-sm-5">{{ label }}:</dt>
  <dd class="col-sm-7">
    {{ value || (imo != "" ? "" : "-") }}
    <img
      v-if="imo != '' && showImg == true"
      class="img-fluid"
      :src="`https://photos.marinetraffic.com/ais/showphoto.aspx?imo=${imo}`"
      @error="hideImg"
    />
  </dd>
</template>

<script>
export default {
  props: ["label", "value", "imo"],
  data() {
    return {
      showImg: true,
    };
  },
  methods: {
    hideImg() {
      this.showImg = false;
    },
  },
};
</script>